<div class="quote-list">
  <div class="tile-content">
    <div class="top-heading" *ngIf="!noData">
      <p class="accNo">
        {{ 'quoteTracking.soldToAcc' | cxTranslate }}
        <span>
          <strong> {{ this.tableData?.soldToCustomer }}</strong>
        </span>
      </p>
      <p>
        {{ 'quoteTracking.legalEntity' | cxTranslate }}
        <span>
          <strong> {{ this.tableData?.legalEntity }}</strong>
        </span>
      </p>
    </div>
    <div class="statusTile">
      <vs-status-tiles
        (filteredTile)="onTileClick($event)"
        [tiles]="quoteTiles"
        [currentStatusType]="firstStatusType"
        [defaultTile]="defaultTile"
      >
      </vs-status-tiles>
    </div>
  </div>
  <div class="sub-content">
    <div class="leftContent" *ngIf="!noData" (click)="refreshList(true)">
      <i class="material-icons icon-size-refresh">refresh</i>
      <span class="btn-txt">{{ 'quoteTracking.refresh' | cxTranslate }}</span>
    </div>
    <div class="leftContent" *ngIf="!noData">
      <span (click)="downloadXls()"
        ><i class="icons download icon-pos icon-size"></i
        ><span class="btn-txt icon-margin"
          >{{ 'quoteTracking.downloadXLS' | cxTranslate }}
        </span></span
      >
    </div>
    <div class="rightContent">
      <!-- <div class="quoteType">
          <label class="pl quoteTypelabel">Quote Type</label>
          <ng-select
                  name="findByQuoteType"
                  [(ngModel)]="findByQuoteType"
                  (change)="changeQuoteType(findByQuoteType)"
                  placeholder="Select"
                  [searchable]="false"
                  [clearable]="false"
                >
                  <ng-option *ngFor="let option of findByQuoteTypeList" value="{{ option.value }}">
                    {{ option.label }}
                  </ng-option>
                </ng-select>
        </div> -->
      <div class="createdby">
        <label class="pl createdbylabel">{{
          'quoteTracking.createdBy' | cxTranslate
        }}</label>
        <ng-select
          [items]="createdby?.createdByList"
          bindLabel="name"
          placeholder="{{ 'quoteTracking.allPlaceholder' | cxTranslate }}"
          [(ngModel)]="selectedCreated"
          (change)="getselectedCreatedby(selectedCreated)"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ item }}
          </ng-template>
        </ng-select>
      </div>
      <div class="dateRange">
        <label class="pl">{{ 'quoteTracking.timePeriod' | cxTranslate }}</label>
        <vs-date-range-picker
          (selectedDateRange)="getDateRange($event)"
          *ngIf="getMonths$ | async"
          [fromMaxDate]="toMinDate"
          [fromMinDate]="fromMaxDate"
          [toMinDate]="toMinDate"
          [toMaxDate]="toMinDate"
          [changeDate]="changeDate"
          (getClearDate)="getClearDate($event)"
        ></vs-date-range-picker>
      </div>
      <div class="search" *ngIf="showSearch">
        <input
          type="text"
          class="form-control search-btn"
          placeholder="{{ 'quoteTracking.searchPlaceholder' | cxTranslate }}"
          #search
          name="search"
          (keyup)="keyUp(search.value, $event)"
        />
        <span
          ><i
            class="material-icons search-icon"
            (click)="modelChange(search.value)"
            >search</i
          ></span
        >
      </div>
      <div class="search" *ngIf="!showSearch">
        <input
          type="text"
          class="form-control search-btn"
          placeholder="{{ 'quoteTracking.searchPlaceholder' | cxTranslate }}"
          [(ngModel)]="searchtext"
          #search
          name="search"
          (keyup)="keyUp(search.value, $event)"
        />
        <span
          ><i
            class="material-icons search-icon"
            (click)="modelChange(search.value)"
            >search</i
          ></span
        >
      </div>
    </div>
  </div>
  <div class="clear-filter">
    <div class="left-content filter-txt" *ngIf="dateRange">
      {{ this.fromDateDisply.formattedDate }} -
      {{ this.toDateDisply.formattedDate }}
      <i class="material-icons" (click)="clearDateFilter()">close</i>
    </div>
    <div class="left-content filter-txt" *ngIf="quoteTypeFlag">
      <span *ngIf="findByQuoteType == 'STD'"> Standard </span>
      <span *ngIf="findByQuoteType == 'FQT'"> Fast track </span>
      <i class="material-icons" (click)="clearQuoteTypeFilter()">close</i>
    </div>
    <div class="left-content filter-txt" *ngIf="searchcreatedby">
      {{ selectedCreated }}
      <i class="material-icons" (click)="clearcreatedbyFilter()">close</i>
    </div>
    <div class="left-content filter-txt" *ngIf="searchFilter">
      {{ 'quoteTracking.search' | cxTranslate }}{{ this.searchtext }}
      <i class="material-icons" (click)="clearSearchFilter()">close</i>
    </div>
    <div class="left-content filter-txt" *ngIf="statusFilter">
      {{ this.displayStatus }}
      <i class="material-icons" (click)="clearStatusFilter()">close</i>
    </div>
    <div *ngIf="clearAll" class="clear" (click)="clear()">
      {{ 'quoteTracking.clear' | cxTranslate }}
    </div>
  </div>
  <div class="example-contaner mat-elevation-z8 tb-parent" *ngIf="!noData">
    <app-scroll-container
      *ngIf="!isLoadMoreInProgress"
      [more]="true"
      [scrollOffset]="400"
      [scrollDelay]="400"
      (scrolled)="loadMoreOrders()"
      [class.full]="full"
      [class.part]="!full"
    >
      <mat-table
        #table
        [dataSource]="dataSource"
        [ngClass]="{ mt: !dateRange }"
        *ngIf="updatedTableData$ | async as tableData; else loading"
      >
        <!-- Position Column -->
        <ng-container matColumnDef="Quote">
          <mat-header-cell *matHeaderCellDef class="tb-heading">{{
            'quoteTracking.hashQuote' | cxTranslate
          }}</mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            class="tb-content"
          >
            <span (click)="selectedQuote(element.quoteId)"> {{ element.quoteId }} </span>
          </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="Created By">
            <mat-header-cell *matHeaderCellDef class="tb-heading"> Created By
              <i class="material-icons" (click)="decreasing()">keyboard_arrow_up</i>
              <i class="material-icons" (click)="increasing()">keyboard_arrow_down</i>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="tb-content"> {{element.quoteCreatedBy}} </mat-cell>
          </ng-container> -->
        <!-- Name Column -->
        <ng-container matColumnDef="QuoteCreatedDate">
          <mat-header-cell *matHeaderCellDef class="tb-heading"
            >{{ 'quoteTracking.quoteCreatedDate' | cxTranslate }}
            <i class="material-icons" (click)="decreasing()"
              >keyboard_arrow_up</i
            >
            <i class="material-icons" (click)="increasing()"
              >keyboard_arrow_down</i
            >
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ element.createdDate | date }}
          </mat-cell>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="QuoteStatus">
          <mat-header-cell *matHeaderCellDef class="tb-heading">{{
            'quoteTracking.quoteStatus' | cxTranslate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ element.quoteStatusLabel }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="QuoteRef">
          <mat-header-cell *matHeaderCellDef class="tb-heading">{{
            'quoteTracking.customerReference' | cxTranslate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ element.quoteReference }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="QuoteTotal">
          <mat-header-cell *matHeaderCellDef class="tb-heading">{{
            'quoteTracking.quoteTotal' | cxTranslate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            {{ getNetPrice(element.quoteTotal) }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="merge">
          <mat-header-cell *matHeaderCellDef class="tb-heading">{{
            'quoteTracking.actions' | cxTranslate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="tb-content">
            <i
              class="material-icons merge-icon"
              matTooltipClass="vs-tooltip"
              matTooltip="{{ 'quoteTracking.mergeQuotes' | cxTranslate }}"
              (click)="mergeQuotes(element)"
              *ngIf="
                (checkUserEnabled(accessibility.SELLABILITYFLAG) | async) &&
                element.quoteStatusCode == CurrentQuoteStatus.PENDING &&
                  !UG_VIEW_ONLY &&
                  !element?.isEditedQuote &&
                  !element?.isAcceptQuote &&
                  !element?.isMergeQuote
              "
              >call_merge</i
            >
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns"></mat-row>
      </mat-table>
    </app-scroll-container>
  </div>
  <div *ngIf="noData" class="noData">
    <div class="img"></div>
    <h2 class="heading">{{ 'quoteTracking.noQuotes' | cxTranslate }}</h2>
  </div>
  <div class="currently-loading-spinner" *ngIf="currentlyLoading">
    <cx-spinner></cx-spinner>
  </div>
</div>
<div *ngIf="apiError" class="apiError">
  <h2 class="heading">
    {{ 'quoteTracking.errorWhileFetching' | cxTranslate }}
  </h2>
</div>
<vs-quote-merge-footer-line
  *ngIf="quotes.length > 0"
  (updateQuotes)="updateQuotes($event)"
  [quotes]="quotes"
  [dateObject]="dateObject"
></vs-quote-merge-footer-line>
<ng-template #loading>
  <div class="cx-spinner" *ngIf="!apiError">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
